import { mergeAttributes, Node } from '@tiptap/core';

export interface AlignBottomOptions {}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    alignBottom: {
      setAlignBottom: () => ReturnType;
    };
  }
}

export const AlignBottom = Node.create<AlignBottomOptions>({
  name: 'alignBottom',
  content: 'block+',
  group: 'block',
  defining: true,

  parseHTML() {
    return [{ tag: 'div.align-bottom' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'align-bottom' }, HTMLAttributes),
      ['div', { class: 'align-bottom-body' }, 0],
      ['div', { class: 'page-break-implicit', 'data-force': 'true' }],
    ];
  },

  addCommands() {
    return {
      setAlignBottom:
        () =>
        ({ commands }) => {
          return commands.wrapIn(this.name);
        },
    };
  },
});
